export type IconsId =
  | 'zoom'
  | 'youtube'
  | 'worship'
  | 'wishlist'
  | 'wishlist-fill'
  | 'vibrate'
  | 'twitter'
  | 'trending'
  | 'tick'
  | 'studio'
  | 'stores'
  | 'sign-out'
  | 'share'
  | 'settings'
  | 'search'
  | 'sample'
  | 'rotate'
  | 'returns'
  | 'residential'
  | 'radio-on'
  | 'radio-off'
  | 'quote'
  | 'promo'
  | 'plus'
  | 'pinterest'
  | 'phone'
  | 'outdoor'
  | 'mute'
  | 'money'
  | 'minus'
  | 'menu'
  | 'lock'
  | 'location'
  | 'instagram'
  | 'info'
  | 'industrial'
  | 'image'
  | 'icon-star'
  | 'hospitality'
  | 'home'
  | 'healthcare'
  | 'grid-4'
  | 'grid-4-fill'
  | 'grid-3'
  | 'grid-3-fill'
  | 'grid-2'
  | 'grid-2-fill'
  | 'grid-1'
  | 'grid-1-fill'
  | 'government'
  | 'filter'
  | 'facebook'
  | 'email'
  | 'education'
  | 'doc'
  | 'diffuse'
  | 'designs'
  | 'delivery'
  | 'credit-card'
  | 'copy'
  | 'commercial'
  | 'close'
  | 'clock'
  | 'chevron'
  | 'chevron-up'
  | 'chevron-right'
  | 'chevron-left'
  | 'chevron-down'
  | 'checkbox'
  | 'checkbox-checked'
  | 'check'
  | 'chat'
  | 'card'
  | 'calendar'
  | 'calc'
  | 'bulb'
  | 'basket'
  | 'arrow-up'
  | 'arrow-right'
  | 'arrow-left'
  | 'arrow-down'
  | 'account'
  | 'absorb';

export type IconsKey =
  | 'Zoom'
  | 'Youtube'
  | 'Worship'
  | 'Wishlist'
  | 'WishlistFill'
  | 'Vibrate'
  | 'Twitter'
  | 'Trending'
  | 'Tick'
  | 'Studio'
  | 'Stores'
  | 'SignOut'
  | 'Share'
  | 'Settings'
  | 'Search'
  | 'Sample'
  | 'Rotate'
  | 'Returns'
  | 'Residential'
  | 'RadioOn'
  | 'RadioOff'
  | 'Quote'
  | 'Promo'
  | 'Plus'
  | 'Pinterest'
  | 'Phone'
  | 'Outdoor'
  | 'Mute'
  | 'Money'
  | 'Minus'
  | 'Menu'
  | 'Lock'
  | 'Location'
  | 'Instagram'
  | 'Info'
  | 'Industrial'
  | 'Image'
  | 'IconStar'
  | 'Hospitality'
  | 'Home'
  | 'Healthcare'
  | 'Grid4'
  | 'Grid4Fill'
  | 'Grid3'
  | 'Grid3Fill'
  | 'Grid2'
  | 'Grid2Fill'
  | 'Grid1'
  | 'Grid1Fill'
  | 'Government'
  | 'Filter'
  | 'Facebook'
  | 'Email'
  | 'Education'
  | 'Doc'
  | 'Diffuse'
  | 'Designs'
  | 'Delivery'
  | 'CreditCard'
  | 'Copy'
  | 'Commercial'
  | 'Close'
  | 'Clock'
  | 'Chevron'
  | 'ChevronUp'
  | 'ChevronRight'
  | 'ChevronLeft'
  | 'ChevronDown'
  | 'Checkbox'
  | 'CheckboxChecked'
  | 'Check'
  | 'Chat'
  | 'Card'
  | 'Calendar'
  | 'Calc'
  | 'Bulb'
  | 'Basket'
  | 'ArrowUp'
  | 'ArrowRight'
  | 'ArrowLeft'
  | 'ArrowDown'
  | 'Account'
  | 'Absorb';

export enum Icons {
  Zoom = 'zoom',
  Youtube = 'youtube',
  Worship = 'worship',
  Wishlist = 'wishlist',
  WishlistFill = 'wishlist-fill',
  Vibrate = 'vibrate',
  Twitter = 'twitter',
  Trending = 'trending',
  Tick = 'tick',
  Studio = 'studio',
  Stores = 'stores',
  SignOut = 'sign-out',
  Share = 'share',
  Settings = 'settings',
  Search = 'search',
  Sample = 'sample',
  Rotate = 'rotate',
  Returns = 'returns',
  Residential = 'residential',
  RadioOn = 'radio-on',
  RadioOff = 'radio-off',
  Quote = 'quote',
  Promo = 'promo',
  Plus = 'plus',
  Pinterest = 'pinterest',
  Phone = 'phone',
  Outdoor = 'outdoor',
  Mute = 'mute',
  Money = 'money',
  Minus = 'minus',
  Menu = 'menu',
  Lock = 'lock',
  Location = 'location',
  Instagram = 'instagram',
  Info = 'info',
  Industrial = 'industrial',
  Image = 'image',
  IconStar = 'icon-star',
  Hospitality = 'hospitality',
  Home = 'home',
  Healthcare = 'healthcare',
  Grid4 = 'grid-4',
  Grid4Fill = 'grid-4-fill',
  Grid3 = 'grid-3',
  Grid3Fill = 'grid-3-fill',
  Grid2 = 'grid-2',
  Grid2Fill = 'grid-2-fill',
  Grid1 = 'grid-1',
  Grid1Fill = 'grid-1-fill',
  Government = 'government',
  Filter = 'filter',
  Facebook = 'facebook',
  Email = 'email',
  Education = 'education',
  Doc = 'doc',
  Diffuse = 'diffuse',
  Designs = 'designs',
  Delivery = 'delivery',
  CreditCard = 'credit-card',
  Copy = 'copy',
  Commercial = 'commercial',
  Close = 'close',
  Clock = 'clock',
  Chevron = 'chevron',
  ChevronUp = 'chevron-up',
  ChevronRight = 'chevron-right',
  ChevronLeft = 'chevron-left',
  ChevronDown = 'chevron-down',
  Checkbox = 'checkbox',
  CheckboxChecked = 'checkbox-checked',
  Check = 'check',
  Chat = 'chat',
  Card = 'card',
  Calendar = 'calendar',
  Calc = 'calc',
  Bulb = 'bulb',
  Basket = 'basket',
  ArrowUp = 'arrow-up',
  ArrowRight = 'arrow-right',
  ArrowLeft = 'arrow-left',
  ArrowDown = 'arrow-down',
  Account = 'account',
  Absorb = 'absorb',
}

export const ICONS_CODEPOINTS: { [key in Icons]: string } = {
  [Icons.Zoom]: '61697',
  [Icons.Youtube]: '61698',
  [Icons.Worship]: '61699',
  [Icons.Wishlist]: '61700',
  [Icons.WishlistFill]: '61701',
  [Icons.Vibrate]: '61702',
  [Icons.Twitter]: '61703',
  [Icons.Trending]: '61704',
  [Icons.Tick]: '61705',
  [Icons.Studio]: '61706',
  [Icons.Stores]: '61707',
  [Icons.SignOut]: '61708',
  [Icons.Share]: '61709',
  [Icons.Settings]: '61710',
  [Icons.Search]: '61711',
  [Icons.Sample]: '61712',
  [Icons.Rotate]: '61713',
  [Icons.Returns]: '61714',
  [Icons.Residential]: '61715',
  [Icons.RadioOn]: '61716',
  [Icons.RadioOff]: '61717',
  [Icons.Quote]: '61718',
  [Icons.Promo]: '61719',
  [Icons.Plus]: '61720',
  [Icons.Pinterest]: '61721',
  [Icons.Phone]: '61722',
  [Icons.Outdoor]: '61723',
  [Icons.Mute]: '61724',
  [Icons.Money]: '61725',
  [Icons.Minus]: '61726',
  [Icons.Menu]: '61727',
  [Icons.Lock]: '61728',
  [Icons.Location]: '61729',
  [Icons.Instagram]: '61730',
  [Icons.Info]: '61731',
  [Icons.Industrial]: '61732',
  [Icons.Image]: '61733',
  [Icons.IconStar]: '61734',
  [Icons.Hospitality]: '61735',
  [Icons.Home]: '61736',
  [Icons.Healthcare]: '61737',
  [Icons.Grid4]: '61738',
  [Icons.Grid4Fill]: '61739',
  [Icons.Grid3]: '61740',
  [Icons.Grid3Fill]: '61741',
  [Icons.Grid2]: '61742',
  [Icons.Grid2Fill]: '61743',
  [Icons.Grid1]: '61744',
  [Icons.Grid1Fill]: '61745',
  [Icons.Government]: '61746',
  [Icons.Filter]: '61747',
  [Icons.Facebook]: '61748',
  [Icons.Email]: '61749',
  [Icons.Education]: '61750',
  [Icons.Doc]: '61751',
  [Icons.Diffuse]: '61752',
  [Icons.Designs]: '61753',
  [Icons.Delivery]: '61754',
  [Icons.CreditCard]: '61755',
  [Icons.Copy]: '61756',
  [Icons.Commercial]: '61757',
  [Icons.Close]: '61758',
  [Icons.Clock]: '61759',
  [Icons.Chevron]: '61760',
  [Icons.ChevronUp]: '61761',
  [Icons.ChevronRight]: '61762',
  [Icons.ChevronLeft]: '61763',
  [Icons.ChevronDown]: '61764',
  [Icons.Checkbox]: '61765',
  [Icons.CheckboxChecked]: '61766',
  [Icons.Check]: '61767',
  [Icons.Chat]: '61768',
  [Icons.Card]: '61769',
  [Icons.Calendar]: '61770',
  [Icons.Calc]: '61771',
  [Icons.Bulb]: '61772',
  [Icons.Basket]: '61773',
  [Icons.ArrowUp]: '61774',
  [Icons.ArrowRight]: '61775',
  [Icons.ArrowLeft]: '61776',
  [Icons.ArrowDown]: '61777',
  [Icons.Account]: '61778',
  [Icons.Absorb]: '61779',
};
